module.exports = new __parcel__URL__("spotlightImage.b6b34352.png").toString();